import { assessmentsHooks } from "pages/School/Assessments"

const useFilterItems = () => {
    let headerItems = assessmentsHooks.useHeaderItems()

    let customHeaderItems = [
        headerItems.category,
        headerItems.assessment_def,
    ]

    return customHeaderItems

}

export default useFilterItems